import { useState } from 'react';
import type { ReactNode } from 'react';

import { FaIcon } from '../icons/FaIcon';

export type DataPanelProps = {
  header?: string;
  cssClass?: string;
  children?: ReactNode;
  beforeItemsTemplate?: ReactNode;
  expandable?: boolean;
};

export function DataPanel({
  header,
  cssClass,
  children,
  beforeItemsTemplate,
  expandable = false,
}: DataPanelProps) {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className={`data-panel ${cssClass ?? ''}`}>
      {header != null &&
        (expandable ? (
          <div
            className="d-flex flex-row justify-content-between align-items-center px-2 py-1 bg-light rounded-1"
            role="button"
            onClick={() => setIsExpanded((expanded) => !expanded)}
          >
            <h2 className="h5 mb-0">{header}</h2>
            <FaIcon icon={isExpanded ? 'fa-regular fa-chevron-down' : 'fa-regular fa-chevron-up'} />
          </div>
        ) : (
          <h2 className="h5 mb-0">{header}</h2>
        ))}

      {beforeItemsTemplate != null && (
        <div className="data-panel__before-items">{beforeItemsTemplate}</div>
      )}

      {isExpanded && (
        <div className="data-panel__content d-flex flex-column" style={{ rowGap: '1px' }}>
          {children}
        </div>
      )}
    </div>
  );
}
